/**
 * Copies a Live Services agent's classification onto the customer's call they
 * claimed with claimLiveServicesCall (leg 1). Leg 2, the agent's own call, is
 * classified as usual; this sends the same classification for leg 1. Failure
 * is left to the caller to log.
 */
import { getClient } from '@api/client';
import { graphql } from '@api/generated';
import { ClassifyLiveServicesOriginCallMutationVariables } from '@api/generated/graphql';

export const CLASSIFY_LIVE_SERVICES_ORIGIN_CALL_MUTATION = graphql(`
  mutation ClassifyLiveServicesOriginCall(
    $tenantId: ID!
    $callId: ID!
    $classification: ChannelClassificationInput!
  ) {
    classifyLiveServicesOriginCall(
      tenantId: $tenantId
      callId: $callId
      classification: $classification
    )
  }
`);

export const classifyLiveServicesOriginCall = async (
  variables: ClassifyLiveServicesOriginCallMutationVariables,
) => {
  const { data } = await getClient().mutate({
    mutation: CLASSIFY_LIVE_SERVICES_ORIGIN_CALL_MUTATION,
    variables,
  });

  return data?.classifyLiveServicesOriginCall ?? false;
};
